import { documentThumbnailSrc, IDocument } from "../models/Document";

export type DocumentPreviewFields = Pick<IDocument, "id" | "contentType" | "requiresReveal" | "thumbnail" | "thumbnailUrl" | "url">;

/**
 * Whether a lead document's tile has anything to open full size. Videos have no thumbnail but
 * still play; anything else with no thumbnail, or one that has already failed to load, would open
 * an empty preview.
 */
export function documentHasPreview(
  doc: DocumentPreviewFields,
  canViewProtected: boolean,
  deadThumbIds: ReadonlySet<string>
): boolean {
  if (doc.requiresReveal) return canViewProtected;
  if (doc.contentType?.includes("video")) return true;

  return !!documentThumbnailSrc(doc) && !deadThumbIds.has(doc.id);
}
